import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Localizer from "@Scripts/Common/Localizer";
import FormHelper from "@Scripts/Common/FormHelper";

@Component({ name: "Feedback" })
export default class Feedback extends Vue {
    public localizer: any = Localizer;
    public isRating: boolean = true;
    public isPositiveRating: boolean = false;
    public isNegativeRating: boolean = false;
    public isOther: boolean = false;
    public isSuccess: boolean = false;
    public isNavigatorOnline: boolean = false;
    public comment: string = null;
    public validationErrors: any[] = [];

    @Prop() readonly pageTitle: string;

    get routes() {
        return (<any>window).App.routes;
    }

    public created() {
        this.isNavigatorOnline = navigator.onLine;
    }

    public setFeedbackRating(rating: number) {
        (<any>window)._paq?.push(["trackEvent", "Feedback", "Rate", this.pageTitle + "_" + rating]);

        if (rating >= 3) {
            this.isPositiveRating = true;
        }
        if (rating < 3) {
            this.isNegativeRating = true;
        }
        this.isRating = false;
    }

    public setFeedbackOpinion(opinion: string) {
        (<any>window)._paq?.push(["trackEvent", "Feedback", "Rate", this.isPositiveRating ? "Like_" + this.pageTitle + "_" + opinion : "Dislike_" + this.pageTitle + "_" + opinion]);

        if (opinion !== "Other") {
            this.isPositiveRating = false;
            this.isNegativeRating = false;
            this.isSuccess = true;
        } else {
            this.isOther = true;
        }
    }

    public setFeedbackComment() {
        this.validationErrors = [];

        if (!this.comment) { }
        else if (this.comment.length > 250) {
            this.validationErrors.push({ name: "Comment", message: this.localizer.get("App.Feedback.Option_Other_ErrorLenght") });
            return;
        }
        else {
            (<any>window)._paq?.push(["trackEvent", "Feedback", "Comment", this.comment]);
        }

        this.isPositiveRating = false;
        this.isNegativeRating = false;
        this.isOther = false;
        this.isSuccess = true;
    }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }
};